// extracted by mini-css-extract-plugin
module.exports =  {"appBar":"appBar_rPGLpphF","fixed":"fixed_k4n_hBNC","headerContent":"headerContent_ajz3Wpkn","headerBar":"headerBar_sq9LmpEM","wideScreen":"wideScreen_Gfq7F4Z2"};